if (!customElements.get('froo-social-share')) {
  customElements.define(
    'froo-social-share',
    class FrooSocialShare extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('.froo-social-share__copy');
        this.message = this.querySelector('.froo-social-share__message');

        this.querySelectorAll('a[target="_blank"]').forEach((link) => {
          link.addEventListener('click', this.openPopup.bind(this));
        });

        if (this.copyButton) this.copyButton.addEventListener('click', this.copyLink.bind(this));
      }

      // Open platform share dialogs in a centred popup on desktop; mobile follows the link normally so apps can take over.
      openPopup(event) {
        if (window.matchMedia('(max-width: 749px)').matches) return;

        const width = 600;
        const height = 560;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        const popup = window.open(
          event.currentTarget.href,
          'froo-social-share',
          `width=${width},height=${height},left=${left},top=${top}`
        );

        // If the popup was blocked, let the link open in a new tab instead.
        if (!popup) return;
        popup.opener = null;
        event.preventDefault();
      }

      copyLink() {
        navigator.clipboard.writeText(this.dataset.url).then(() => {
          this.message.textContent = this.message.dataset.success;
          this.copyButton.classList.add('froo-social-share__copy--copied');

          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            this.message.textContent = '';
            this.copyButton.classList.remove('froo-social-share__copy--copied');
          }, 2000);
        });
      }
    },
  );
}
